export default __webpack_public_path__ + "static/media/enviar-referencia.ca50417f.svg";